(function offerController(){
  'use strict';
  var frame=0;
  var messageNode=null;
  var messageObserver=null;
  function schedule(){
    if(frame)return;
    frame=requestAnimationFrame(refresh);
  }
  function watchMessage(node){
    if(messageNode===node)return;
    if(messageObserver)messageObserver.disconnect();
    messageNode=node;
    messageObserver=new MutationObserver(schedule);
    messageObserver.observe(node,{childList:true,subtree:true,characterData:true});
  }
  function refresh(){
    frame=0;
    var dock=document.querySelector('.buce-v10-sticky[data-buce-v10-sticky]');
    var benefit=dock&&dock.querySelector('[data-buce-dock-benefit]');
    if(!benefit)return;
    var label=benefit.querySelector('[data-buce-dock-message]');
    if(!label)return;
    watchMessage(label);
    var state=window.BuceAH&&typeof window.BuceAH.state==='function'?window.BuceAH.state():null;
    if(benefit.hidden||!state||state.confirmed!==true)return;
    var pairs=Math.max(0,Math.floor(Number(state.pairs)||0));
    var tiers={1:15000,2:25000,3:40000,4:50000};
    var top='Agrega otro par',bottom='';
    if(Object.prototype.hasOwnProperty.call(tiers,pairs)){
      bottom='Y ahorra '+String.fromCharCode(36)+tiers[pairs].toLocaleString('es-CO');
    }else if(pairs===5){
      bottom='Y llévate 1 gratis';
    }else if(pairs>=6){
      top='¡Par gratis!';
      bottom='Beneficio aplicado';
    }else return;
    var existing=label.querySelector('.buce-offer-short-copy');
    if(!existing||existing.children.length!==2||existing.children[0].textContent!==top||existing.children[1].textContent!==bottom||label.childNodes.length!==1){
      var copy=document.createElement('span');
      copy.className='buce-offer-short-copy';
      var line1=document.createElement('span'),line2=document.createElement('span');
      line1.textContent=top;line2.textContent=bottom;
      copy.append(line1,line2);
      label.replaceChildren(copy);
    }
    var progress=benefit.querySelector('[role="progressbar"]');
    if(progress)progress.setAttribute('aria-valuetext',top+'. '+bottom);
  }
  function start(){
    document.addEventListener('buce:ah-state',schedule);
    document.addEventListener('buce:cart-status',schedule);
    document.addEventListener('shopify:section:load',schedule);
    var dockObserver=new MutationObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        var nodes=entries[i].addedNodes;
        for(var j=0;j<nodes.length;j++){
          var node=nodes[j];
          if(node.nodeType===1&&typeof node.matches==='function'&&node.matches('[data-buce-v10-sticky]')){schedule();return;}
        }
      }
    });
    dockObserver.observe(document.body,{childList:true});
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
